// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__3Z4eF","file":"styles_file__3Zntx"};